<template>
  <b-col class="col-12 position-relative">
    <b-link v-if="id" class="text-body" :title="$t('queens.delete')" @click.prevent="clickDelete">
      <span class="icon-delete_filled" aria-hidden="true"></span>
    </b-link>
    <b-modal id="confirmDeleteQueen" centered hide-header-close @ok="doDelete">
      <template slot="modal-title">
        {{ $t('queens.confirm_delete.title') }}
      </template>
      {{ $t('queens.confirm_delete.text') }}
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()">
          {{ $t('queens.confirm_delete.no') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="ok()">
          {{ $t('queens.confirm_delete.yes') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal :id="'offLineModalQueen_'+ id" centered hide-header-close @ok="hideModal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>
export default {
  name: 'QueenDeleteList',
  props: ['id', 'colony', 'apiary'],
  methods: {
    clickDelete () {
      if (navigator.onLine) {
        this.showModal()
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalQueen_' + this.id)
    },
    hideModal () {
      this.$bvModal.hide('offLineModalQueen_' + this.id)
    },
    showModal () {
      this.$bvModal.show('confirmDeleteQueen')
    },
    async doDelete () {
      let result
      try {
        this.$emit('confirmDelete', 'Yes')
        const token = await this.$api.user.getToken()
        result = await this.$api.queens.deleteItem({ id: this.id, token })
        // this.$router.go(0)
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.$router.replace('/login')
        }
        return false
      }
      // this.$router.replace('/colony/' + this.colony + '/' + this.apiary)
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  h2 {
    font-size: 1.5rem;
  }
</style>
